export default function WildcraftLogo({ size = 80, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Outer leaf shape */}
      <path d="M60 8C60 8 95 28 95 60C95 92 60 112 60 112C60 112 25 92 25 60C25 28 60 8 60 8Z" 
        fill="#1B3A1A" opacity="0.9"/>
      {/* Inner leaf veins */}
      <path d="M60 20C60 20 82 34 82 60C82 86 60 100 60 100" stroke="#4A7C3F" strokeWidth="2" fill="none" opacity="0.7"/>
      <path d="M60 20C60 20 38 34 38 60C38 86 60 100 60 100" stroke="#4A7C3F" strokeWidth="2" fill="none" opacity="0.7"/>
      {/* Center vein */}
      <path d="M60 24V96" stroke="#7D8B69" strokeWidth="1.5" opacity="0.5"/>
      {/* Horizontal veins */}
      <path d="M42 45L60 40L78 45" stroke="#7D8B69" strokeWidth="1" fill="none" opacity="0.4"/>
      <path d="M38 60L60 55L82 60" stroke="#7D8B69" strokeWidth="1" fill="none" opacity="0.4"/>
      <path d="M42 75L60 70L78 75" stroke="#7D8B69" strokeWidth="1" fill="none" opacity="0.4"/>
      {/* Flame accent inside leaf */}
      <path d="M60 50C60 50 52 58 52 65C52 72 56 75 60 75C64 75 68 72 68 65C68 58 60 50 60 50Z" 
        fill="#B8860B" opacity="0.6"/>
      <path d="M60 56C60 56 56 61 56 65C56 69 58 71 60 71C62 71 64 69 64 65C64 61 60 56 60 56Z" 
        fill="#D4A843" opacity="0.7"/>
    </svg>
  );
}

